import moment from "moment"

const INITIAL_STATE = {
  grafico: {
    options: {
      chart: {
        id: 'apexchart-example'
      },
      xaxis: {
        categories: []
      }
    },
    series: [
{
      name: 'series-1',
      data: []
    }
]
  },
  frequencia: 'diario',
  dadosFiltro: {
    dataDe: '',
    dataAte: '',
    status: { value: '', label: '' },
    fornecedor: { value: 0, label: '' },
    categoria: { value: 0, label: '' },
    clear: false
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'DRE_DATA_FETCH': {
      let graficoCopy = {...state.grafico}
      graficoCopy = action.payload

      return { ...state, grafico: graficoCopy }
    }
    case 'DRE_FREQUENCIA_CHANGE': {
      let copyFrequencia = {...state.frequencia}
      copyFrequencia = action.payload
      console.log(action.payload, 'adsva')
      return { ...state, frequencia: action.payload }
    }
    case 'DRE_SET_FILTRO_CLEAR': {
      const dadosFiltroCopy = {
        dataDe: '',
        dataAte: '',
        status: { value: '', label: '' },
        fornecedor: { value: 0, label: '' },
        categoria: { value: 0, label: '' },
        clear: false
      }
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }

    case 'DRE_SET_FILTRO': {
      const dadosFiltroCopy = { ...state.dadosFiltro }
      dadosFiltroCopy[action.campo] = action.valor
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    default:
      return state
  }
}